import { useState } from 'react';
import { debounce } from 'lodash';

export const useSearch = (onSearch, delay = 500) => {
  const [search, setSearch] = useState('');

  const handleSearchChange = debounce((value) => {
    setSearch(value);
    if (onSearch) {
      onSearch(value);
    }
  }, delay);

  return {
    search,
    handleSearchChange
  };
}; 